import { FC, Fragment } from 'react';

import { Controller } from 'react-hook-form';
import { Col, FormFeedback, FormGroup, Input, Label } from 'reactstrap';

import classNames from 'classnames';
import { get } from 'radash';

import { Else, If, Then } from '@hsp/react-component-library';
import { isEmpty } from '@hsp/utilities';

import { Client as ClientSelect } from 'components/client';
import { s } from 'utilities/strings';

import { useClientConfiguration } from './hooks';

const Client: FC = () => {
  const { control, errors, readOnly } = useClientConfiguration();

  return (
    <FormGroup row>
      <Label sm={4}>{s(['Site.Client'])}</Label>
      <Col>
        <Controller
          control={control}
          name="client"
          render={({ field: { onChange, value } }) => (
            <>
              <If condition={readOnly}>
                <Then>
                  {() => (
                    <Fragment key={value?.name}>
                      <Input
                        className={classNames({
                          'is-invalid': get(errors, 'client.type') === 'custom',
                        })}
                        defaultValue={value?.name}
                        placeholder={s(['Site.Select', 'Site.Audience'])}
                        plaintext={readOnly}
                        readOnly={readOnly}
                        type="text"
                      />
                    </Fragment>
                  )}
                </Then>
                <Else>
                  {() => (
                    <ClientSelect
                      className={classNames({
                        'is-invalid': get(errors, 'client.type') === 'custom',
                      })}
                      onSelected={(controlValue) => onChange(isEmpty(controlValue) ? null : controlValue)}
                      selected={value}
                      useExternal
                    />
                  )}
                </Else>
              </If>
              <FormFeedback type="invalid">{get(errors, 'client.message')}</FormFeedback>
            </>
          )}
        />
      </Col>
    </FormGroup>
  );
};

export default Client;
